import { HtmlEntities } from '@utils';

import { getAlbumsStore, AlbumsStore, IAlbumsStoreJSON } from './AlbumsStore';
import { getArtistsStore, ArtistsStore, IArtistsStoreJSON } from './ArtistsStore';
import { getPlaylistsStore, PlaylistsStore, IPlaylistsStoreJSON } from './PlaylistsStore';
import { getTracksStore, TracksStore, ITracksStoreJSON } from './TracksStore';
import { getUsersStore, UsersStore, IUsersStoreJSON } from './UsersStore';

export * from './AlbumsStore';
export * from './ArtistsStore';
export * from './PlaylistsStore';
export * from './TracksStore';
export * from './UsersStore';

export interface IAppStateJSON {
	albumsStore: IAlbumsStoreJSON;
	artistsStore: IArtistsStoreJSON;
	playlistsStore: IPlaylistsStoreJSON;
	tracksStore: ITracksStoreJSON;
	usersStore: IUsersStoreJSON;
}

export interface IAppState {
	albumsStore: AlbumsStore;
	artistsStore: ArtistsStore;
	playlistsStore: PlaylistsStore;
	tracksStore: TracksStore;
	usersStore: UsersStore;

	toJSON(): IAppStateJSON;
	fromJSON(data: IAppStateJSON): void;
}

let appState: IAppState;

export const resetState = () => {
	const albumsStore = getAlbumsStore();
	const artistsStore = getArtistsStore();
	const playlistsStore = getPlaylistsStore();
	const tracksStore = getTracksStore();
	const usersStore = getUsersStore();

	appState = {
		albumsStore,
		artistsStore,
		playlistsStore,
		tracksStore,
		usersStore,

		toJSON() {
			return {
				albumsStore: albumsStore.toJSON(),
				artistsStore: artistsStore.toJSON(),
				playlistsStore: playlistsStore.toJSON(),
				tracksStore: tracksStore.toJSON(),
				usersStore: usersStore.toJSON(),
			};
		},

		fromJSON(data: IAppStateJSON): void {
			this.albumsStore.fromJSON(data.albumsStore);
			this.artistsStore.fromJSON(data.artistsStore);
			this.playlistsStore.fromJSON(data.playlistsStore);
			this.tracksStore.fromJSON(data.tracksStore);
			this.usersStore.fromJSON(data.usersStore);
		},
	};
};

export const parseInitialState = () => {
	try {
		appState.fromJSON(JSON.parse(HtmlEntities.decode(document.getElementById('initial-mobx-state').innerHTML)));
	} catch (err) {}
};

export const getState = () => appState;
